import styled from "@emotion/styled";
import { default as FilledCircledTickRaw } from "/public/assets/filled-circled-tick.svg?react";

export const FilledCircledTick = styled(FilledCircledTickRaw)`
  color: var(--tw-green-500);
`;
